import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, Observable, of } from 'rxjs';
import { OrderMode } from '@models/terminal/terminal.model';
import { MealPlanService } from '@services/meal-plan.service';
import { TerminalService } from '@services/terminal.service';
import { AppRoutes } from '@helpers/app-routes';

export const chooseOrderTypeResolver: ResolveFn<OrderMode[]> = (): Observable<
  OrderMode[] | RedirectCommand
> => {
  const router = inject(Router);
  const mealPlanService = inject(MealPlanService);
  const toastr = inject(ToastrService);
  const translate = inject(TranslateService);
  const modes = inject(TerminalService).orderModes();

  if (!modes.length) {
    toastr.error(
      translate.instant('choose_order_type.errors.no_mode_message'),
      translate.instant('choose_order_type.errors.no_mode_title'),
    );
    return router.navigated
      ? EMPTY
      : of(new RedirectCommand(router.parseUrl(`/${AppRoutes.scanPage}`)));
  }

  if (modes.length === 1) {
    if (modes[0] === 'by_course') {
      mealPlanService.clearMealPlan();
      return of(new RedirectCommand(router.parseUrl(`/${AppRoutes.order}`)));
    }
    return of(new RedirectCommand(router.parseUrl(`/${AppRoutes.chooseMealPlan}`)));
  }

  return of(modes);
};
